import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-slim-topbar',
	templateUrl: './slim.topbar.component.html',
	styles: `
		img {
			-webkit-user-drag: none;
			user-drag: none;
		}
	`
})
export class SlimTopBarComponent{
	constructor(
		private router: Router,
	) {}

	backToLogin(): void {
		this.router.navigate(['/login']);
	}
}
